import { gql, useQuery } from '@apollo/client';
import * as React from 'react';

import { InteractionPage_currentOidcInteraction } from './graphql-types/InteractionPage_currentOidcInteraction';

import { InteractionPageContent } from './components';

const GET_CURRENT_OIDC_INTERACTION = gql`
  query InteractionPage_currentOidcInteraction {
    currentOidcInteraction {
      result {
        interaction {
          prompt {
            name
          }
        }
      }
    }
  }
`;

export const InteractionPage: React.FC = () => {
  const { data, loading } = useQuery<InteractionPage_currentOidcInteraction>(
    GET_CURRENT_OIDC_INTERACTION
  );

  if (loading) {
    return null;
  }

  if (!data?.currentOidcInteraction) {
    return null;
  }

  return <InteractionPageContent data={data?.currentOidcInteraction} />;
};
